<template>
    <v-container class="d-flex justify-center align-center pa-0 fill-height">
        <v-icon color="primary" :icon="icons.mdiPlayCircleOutline" class="cursor-pointer"/>
    </v-container>
</template>

<script setup>
    import { ref } from 'vue';
    import {mdiPlayCircleOutline} from '@mdi/js';

    const props = defineProps(['params']);

    const stringValue = ref(props.params.value ?? '');
    const icons = {
        mdiPlayCircleOutline
    };

    function getValue() {
        return stringValue.value;
    }

    // ag-grid calls getValue() on this component's public instance to implement the
    // ICellEditor contract — only visible through defineExpose() on a <script setup> component.
    defineExpose({ getValue });
</script>
